(function () {
    "use strict";

    // @ngInject
    function NetworkEditProjectControllerCtor($scope, $injector, $filter, $stateParams, _, UsersManager,
                                              NetworkManager, NetworkService, AnalyticsService, ModelFactory, $timeout, PopupMessageService) {

        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'NetworkEditProjectController';
        this.projectId = $stateParams.project_id;
        this.NetworkManager = NetworkManager;
        this.NetworkService = NetworkService;
        this.AnalyticsService = AnalyticsService;
        this.ModelFactory = ModelFactory;
        this._ = _;
        this.projectData = this.projectData || {};
        this.UsersManager = UsersManager;
        this.currUser = this.NetworkManager.getNetworkCurrUser();
        this.deleting = false;
        this.PopupMessageService = PopupMessageService;
        this.locationGeocoded = false;
        this.setPhotoAsDefaultText = 'Set as cover';
        this.photoIsCoverText = 'Current project cover';

        if (this.projectId) {
            this.project = this.NetworkManager.getProject(this.projectId);
        } else {
            // this.project = this.ModelFactory.newNetworkProjectModel();
            this.project = this.NetworkManager.createNetworkProject({});
            // this.project.members = [this.currUser];
            // this.project.member_ids = [this.currUser._id];
            this.selectedProjectType = this.NetworkService.getSelectedProjectTypeFromEnum();
            $timeout(function() {
                angular.element('#network-project-name').focus();
            }.bind(this), 500);
        }

        this.projectTypes = this.NetworkService.getProjectTypesEnum();
        this.isSavingProject = false;
        this.dropdownChanged = false;
        this.vendorTagged = false;
        this.imageAdded = false;
        this.imageDeleted = false;
        this.coverChanged = false;
        
        this.projectLoaded = false;
        
        this.$stateParams = $stateParams;

        if (this.$stateParams && this.$stateParams.focus_id && this.$stateParams.focus_id.length) {
            $timeout(function() {
                angular.element('#' + this.$stateParams.focus_id).focus();
            }.bind(this), 500);
        }

        this.project.on('success', function(){

            if (!this.projectId){
                this.projectId = this.project._id;
                this.goToState(this.AppStates.root_network_edit_project, {project_id: this.projectId},{
                    // prevent the events onStart and onSuccess from firing
                    notify:false,
                    // prevent reload of the current state
                    reload:false,
                    // replace the last record when changing the params so you don't hit the back button and get old params
                    location:'replace',
                    // inherit the current params on the url
                    inherit:true
                });
            }

            // Don't allow non-creators to edit project
            if (this.currUser._id !== this.project.creator._id) {
                this.goToState(this.AppStates.root_network_project, {project_id: this.projectId});
            }

            // Don't let photo upload success clear projectData fields
            if (!this.projectLoaded) {
                this.projectData = angular.extend(this.projectData, {
                    _id: this.project._id,
                    project_name: this.project.project_name,
                    project_type: this.project.project_type,
                    project_date: $filter('date')(this.project.project_date, "MMM dd, yyyy"),
                    description: this.project.description,
                    guests: this.project.guests,
                    tags: this.project.tags!== null && this.project.tags.length ? this.project.tags.join(', ') : '',
                    location: this.project.location,
                    member_ids: this.project.member_ids,
                    coordinates: this.project.coordinates
                });
            
                this.projectLoaded = true;
            }
            
            this.selectedProjectType = this.NetworkService.getSelectedProjectTypeFromEnum(this.project);
        }.bind(this));

    }

    Controllers.NetworkEditProjectController = Class(Controllers.BaseController, {

        constructor: NetworkEditProjectControllerCtor,
        
        isNewProject: function isNewProject() {
            return this.project.status === 'draft';
        },

        update: function update() {
            /* Save project information */

            if(this.isFormDirty()){
                this.isSavingProject = true;
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_save_project, this.projectData);
                if (this.projectId) {

                    if (this.isNewProject()){
                        // only for first time that draft is been saved
                        this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.network_project_publish, {projectId: this.project._id});
                    }

                    // Edit existing project
                    this.NetworkManager.updateNetworkProject(this.project, this.projectData).then(
                        function success(){
                            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.network_edit_project, {projectId: this.project._id});
                            this._handleSaveSuccess();
                            this.goToState(this.AppStates.root_network_project, {project_id: this.project._id});
                        }.bind(this),
                        function error(resp){
                            this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.network_edit_project, resp);
                            this.lastError = resp.data.error_message || resp.data;
                        }.bind(this))
                        .finally(function finallyHandler() {
                            this.isSavingProject = false;
                        }.bind(this));
                } else {
                    // Create a new project
                    this.project = this.NetworkManager.createNetworkProject(this.projectData);
                    this.project.on('success', function onSuccess(){
                        this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.network_create_project, {projectId: this.project._id});
                        this._handleSaveSuccess();
                        this.isSavingProject = false;
                    }.bind(this));
                    this.project.on('error', function onError(message){
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.network_create_project, message);
                        this.lastError = message;
                        this.isSavingProject = false;
                    }.bind(this));
                }
            }
        },

        cancel: function cancel() {
            if (this.isNewProject()) {
                this.deleteProject();
            } else {
                this.goToState(this.AppStates.root_network_project, {project_id: this.projectId});
            }
        },

        setProjectType: function setProjectType(type) {
            this.projectData.project_type = type.key;
            this.selectedProjectType = type;
            this.dropdownChanged = true;
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_edit_project_type, type.text);
        },

        isFormDirty: function isFormDirty() {
            return (this.projectForm.$dirty || this.dropdownChanged || this.vendorTagged || this.imageAdded || this.coverChanged || this.imageDeleted) && this.projectForm.$valid;
        },

        _handleSaveSuccess: function _handleSaveSuccess(){
            // Clear validations
            if (angular.isDefined(this.projectForm))
            {
                this.projectForm.$setPristine();
            }
            this.dropdownChanged = false;
        },
        createFileViewModel: function createFileModel(image) {
            var self = this;
            var fileViewModel = {
                instance: self.project, //the instance of the model containing these files
                type: 'project_gallery_image',
                dontUpdateServer: true,
                uploading: false,
                uploaded: true,
                dataUrl: null,
                url: null,
                file: null,
                progress: 0
            };

            if (image) {
                //add the attributes of the file to upload on the view-model
                this._.extend(fileViewModel, image);
            }

            return fileViewModel;
        },

        deleteImage: function deleteImage(image_id)
        {

            this.imageDeleted = true;
            // First send the delete to the server
            this.NetworkManager.deleteAsset(this.project, image_id);

            // Second update the model immediately for better UI experience
            var index;
            this._.any(this.project.gallery_assets, function (item, idx) {
                if (item._id === image_id) {
                    index = idx;
                    return true; // brake the iteration
                }
            });

            if (index !== undefined) {
                this.project.gallery_assets.splice(index, 1);
            }

            if (this.project.gallery_assets.length === 0) {
                this.project.default_cover_image_id = null;
            } else if (this.project.default_cover_image_id === image_id) {
                this.setFirstImageAsDefaultCoverImage();
            }
        },

        analyticsProperties: function analyticsProperties() {
            return {
                projectId: this.project._id
            };
        },

        openNetworkTagVendors: function openNetworkTagVendors() {
            this.NetworkService.tagNetworkVendors(this.project).then(
                function onMembersAdded(resp){
                    this.projectData["member_ids"] = this.project.member_ids;
                    this.vendorTagged = true;
                }.bind(this));
        },

        addImage: function addImage(s3response,type) {
            this.imageAdded = true;

            return this.NetworkManager.addImageToGallery(this.project, s3response, type).then(function () {
                if (this.project.default_cover_image_id == null) {
                    this.setFirstImageAsDefaultCoverImage();
                }
            }.bind(this));
        },
        
        deleteProject: function deleteProject() {

            var self = this;

            var deleteConfirmed = function deleteConfirmed(){
                self.deleting = true;
                self.analyticsArgs = {
                    projectId : self.project._id
                };

                self.NetworkManager.deleteNetworkProject(self.currUser, self.project._id).then(
                    function success() {
                        self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.network_cancel_deleted_project, self.analyticsArgs);
                    },
                    function error() {
                        self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.network_cancel_deleted_project_error, self.analyticsArgs);
                    }
                ).finally(function done() {
                    self.deleting = false;
                    self.goToState(self.AppStates.root_network_my_profile);
                });
            };

            this.PopupMessageService.showConfirm(this.PopupMessageService.severityTypes.warning,
                'NETWORK.PROJECT._CONFIRM_CANCEL_DELETE_',
                deleteConfirmed);
        },

        blurLocation: function blurLocation(){
            if(!this.locationGeocoded && this.projectData.coordinates){
                this.projectData.coordinates = [];
            }
        },

        updateCoordinates: function updateCoordinates(geocodeResult){
            if(geocodeResult.geometry) {
                var longitude = geocodeResult.geometry.location.lng();
                var latitude = geocodeResult.geometry.location.lat();
                // MongoDB stores geospatical coordinates as long, lat
                this.projectData.coordinates = [longitude, latitude];
                this.locationGeocoded = true;
            }
        },

        setFirstImageAsDefaultCoverImage: function setFirstImageAsDefaultCoverImage() {
            var image_id = this.project.gallery_assets[0]._id;
            this.NetworkManager.setProjectCoverImage(this.project, image_id);
            this.project.default_cover_image_id = image_id;
            this.coverChanged = true;
        },

        setDefaultCoverImage: function setDefaultCoverImage(image_id) {
            this.NetworkManager.setProjectCoverImage(this.project, image_id);
            this.project.default_cover_image_id = image_id;
            this.coverChanged = true;
        },

        onSaveProjectSuccess: function onSaveProjectSuccess(project) {
            this.goToState(this.AppStates.root_network_project, {project_id: project._id});
        },

        onCancelProject: function onCancelProject() {
            this.goToState(this.AppStates.root_network_my_profile);
        },

        onProjectSuccess: function onProjectSuccess(project) {
            this.goToState(this.AppStates.root_network_edit_project, {project_id: project._id},{
                // prevent the events onStart and onSuccess from firing
                notify:false,
                // prevent reload of the current state
                reload:false,
                // replace the last record when changing the params so you don't hit the back button and get old params
                location:'replace',
                // inherit the current params on the url
                inherit:true
            });
        }

    });
}());
